import { FC, Fragment } from 'react';

import { Col, Row } from 'reactstrap';

import { If, Then } from '@hsp/react-component-library';
import { isEmpty } from '@hsp/utilities';

import { GlobalFilter } from 'components/table/components/global-filter';
import { TableToolbarProps } from 'types/components/table/components/toolbar';

const TableToolbar: FC<TableToolbarProps> = ({
  Filter = GlobalFilter,
  children,
  enableFilter = false,
  filterPlaceHolder,
}) => {
  return (
    <If condition={enableFilter || !isEmpty(children)}>
      <Then>
        {() => (
          <Fragment>
            <Row>
              <Col>
                <Filter
                  enabled={enableFilter}
                  placeholder={filterPlaceHolder}
                />
              </Col>
              <Col className="d-flex justify-content-end">{children}</Col>
            </Row>
            <hr />
          </Fragment>
        )}
      </Then>
    </If>
  );
};

export default TableToolbar;
